import { WalletIcon } from "assets/icons/WalletIcon";
import ChevronBack from "assets/svgComponents/buyTokenForm/ChevronBack";
import CopyIcon from "assets/svgComponents/buyTokenForm/CopyIcon";
import InvestNowButton from "assets/svgComponents/buyTokenForm/InvestNowButton";
import ArrowForwardColoredIcon from "assets/svgComponents/PresaleBlock/ArrowForwardColoredIcon";
import { ConnectWallet } from "assets/svgComponents/PresaleBlock/ConnectWallet";
import { InfoIcon } from "assets/svgComponents/PresaleBlock/InfoIcon";
import clsx from "clsx";
import { Loader } from "components/Loader";
import { NetworkKey, PaymentMethod, networkData } from "constants/methods";
import { useCopyToClipboard } from "hooks/useCopyToClipboard";
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  gradientRowBgClass,
  investButtonClass,
  shadowAndBorderClass,
} from "screens/Dashboard/utils/classes";
import { authApi } from "services/auth";
import { tokensApi } from "services/tokens";
import { appStore } from "store";
import { Button } from "ui-kit/Button";
import { calcAmountOfTokensToShow, truncateMiddle } from "utils";
import { useAccount } from "wagmi";
import { PaymentFormType, Step } from "./scheme";
import { AttsIcon } from "assets/svgComponents/PresaleBlock/ConnectWallet copy";

interface SendDepositProps {
  paymentInUSD: number;
  preselectedMethod: PaymentMethod;
  setIsPaymentDialogOpen: Dispatch<SetStateAction<boolean>>;
  referralCode: string;
  handleChangeStep: (step: Step) => void;
  actualPaymentAmount: number;
}

export function CompletedStep({
  paymentInUSD,
  preselectedMethod,
  setIsPaymentDialogOpen,
  referralCode,
  handleChangeStep,
  actualPaymentAmount,
}: SendDepositProps) {
  const form = useFormContext<PaymentFormType>();
  const { currentRound, currentBonus, currentReferralProgram } = appStore();
  const { t } = useTranslation();
  const [isPymentModalOpened, setIsPymentModalOpened] = useState(false);
  const [isSucces, setIsSucces] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { address: connectedWalletAddress } = useAccount();

  if (!form) {
    throw new Error("This component must be used within a <FormProvider />");
  }

  const tokens = calcAmountOfTokensToShow(
    paymentInUSD,
    currentRound,
    referralCode,
  );

  const toensWithoutBonus = calcAmountOfTokensToShow(
    paymentInUSD,
    currentRound,
    false,
  );

  const [copiedText, copyToClipboard] = useCopyToClipboard(2000);
  const handleCopy = () => {
    copyToClipboard(String(connectedWalletAddress));
    toast.success("Address copied!");
  };

  const referralBonusToShow =
    currentReferralProgram?.refereeBonusPercentAmount && tokens
      ? (Number(tokens) - Number(toensWithoutBonus)).toFixed(2)
      : "0";

  return (
    <>
      {" "}
      <div
        className={clsx(
          "flex flex-col max-lg:gap-[8px] rounded-[28px] max-lg:rounded-[28px] max-lg:before:!rounded-[28px] before:!rounded-[28px] bg-[#111111] p-[12px] max-lg:p-[12px] pb-[14px] w-[445px] max-lg:w-full",
          shadowAndBorderClass,
        )}
      >
        <div
          className={clsx(
            "flex items-center justify-between rounded-[16px] max-lg:rounded-[12px] mb-[20px] before:!rounded-[16px] max-lg:before:!rounded-[12px] p-[8px] max-lg:p-[8px]",
            gradientRowBgClass,
          )}
        >
          <div className="flex items-center gap-[16px] max-lg:gap-[12px]">
            <button
              className={clsx(
                "w-[31px] h-[31px] max-lg:w-[31px] max-lg:h-[31px] bg-[#252525] text-white hover:scale-[1.1] cursor-pinter rounded-full flex items-center justify-center flex-shrink-0",
                shadowAndBorderClass,
              )}
              onClick={() => setIsPaymentDialogOpen(false)}
            >
              <ChevronBack className="max-lg:w-[23px] max-lg:h-[23px]" />
            </button>
            <h2 className="text-[20px] max-lg:text-16m font-luxora-medium leading-[110%] text-white">
              {t("Purchase Completed")}
            </h2>
          </div>

          <div
            className={clsx(
              "w-[88px] max-lg:w-[88px] h-[31px] max-lg:h-[31px] flex items-center justify-center rounded-[8px] max-lg:rounded-[8px] before:!rounded-[8px] max-lg:before:!rounded-[8px] bg-[#252525]",
              shadowAndBorderClass,
            )}
          >
            <div className="text-[16px] max-lg:text-[16px] text-white">
              {" "}
              Step 3/3
            </div>
          </div>
        </div>
        <div
          className={clsx(
            "bg-[#1a1a1a] p-[8px] max-lg:p-[8px] flex flex-col gap-[4px] max-lg:gap-[4px] rounded-[16px] max-lg:rounded-[16px] before:!rounded-[16px] max-lg:before:!rounded-[16px]",
            shadowAndBorderClass,
          )}
        >
          <div className="flex flex-col items-center py-[12px] max-lg:py-[12px] ">
            <div className="text-[20px] max-lg:text-[20px] font-[500] max-lg:font-[500] text-white">
              Thanks for purchasing $ATTS!
            </div>
            <div className="text-[16px] max-lg:text-[16px] font-[400] max-lg:font-[400] text-white/40">
              Your Payment is being Processed
            </div>
          </div>
          <div className="flex flex-col gap-[4px] max-lg:gap-[4px]">
            <div className="flex items-center justify-between border-[2px] rounded-[16px] max-lg:rounded-[12px] max-lg:pt-[4px] max-lg:pr-[16px] lg:py-[3px] lg:pl-[3px] lg:pr-[16px] border-[#252525]">
              <div className="flex items-center gap-[1px]">
                <AttsIcon className="size-[46px] max-lg:size-[39px]" />
                <div className="text-[16px] max-lg:text-16m font-luxora-regular leading-normal text-white">
                  ATTS
                </div>
              </div>
              <div
                className={` max-w-[90px] max-lg:max-w-full ${
                  String(tokens).length < 10
                    ? "text-[16px] max-lg:text-16m"
                    : "text-[12px] max-lg:text-14m break-all"
                }  font-luxora-regular leading-[110%] text-white`}
              >
                {actualPaymentAmount.toFixed(2)}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-[4px] max-lg:gap-[4px]">
            <div className="flex items-center justify-between border-[2px] rounded-[16px] max-lg:rounded-[12px] max-lg:p-[4px] max-lg:pr-[16px] lg:py-[8px] lg:pl-[8px] lg:pr-[16px] border-[#252525]">
              {" "}
              <div className=" max-lg:rounded-[8px] max-lg:h-[32px] h-[32px] rounded-[8px] flex items-center gap-[8px] max-lg:gap-[8px]">
                {" "}
                <ConnectWallet className="max-lg:w-[21px] max-lg:h-[21px]" />
                <div className="max-lg:pl-[4px] text-[14px] max-lg:text-14m font-luxora-regular text-left leading-[110%] text-white/40">
                  {t("Wallet to receive $ATTS")}:
                </div>
              </div>
              <div
                className="text-[16px] max-lg:text-16m font-luxora-regular leading-normal text-white truncate max-lg:max-w-[188px] max-w-[288px]"
                title={connectedWalletAddress}
              >
                {truncateMiddle(String(connectedWalletAddress), 3, 3)}
              </div>
            </div>
          </div>
        </div>

        <div
          className={clsx(
            "bg-[#1a1a1a] flex gap-[12px] max-lg:gap-[12px] py-[8px] max-lg:py-[8px] px-[12px] max-lg:px-[12px] mt-[12px] max-lg:mt-[12px] rounded-[16px] max-lg:rounded-[16px] before:!rounded-[16px] max-lg:before:!rounded-[16px]",
            shadowAndBorderClass,
          )}
        >
          <InfoIcon className="w-[24px] max-lg:w-[24px] h-[24px] max-lg:h-[24px] min-w-[24px] max-lg:min-w-[24px] min-h-[24px] max-lg:min-h-[24px]" />
          <div className="text-[16px] max-lg:text-[16px] text-white/40 leading-[110%] font-[400] max-lg:font-[400]">
            If the transaction is correct - your tokens will be sent to
            connected wallet in up to 10 minutes. You can check if you received
            tokens on our dashboard.
          </div>
        </div>

        <div className="flex gap-[8px] mt-[144px] max-lg:mt-[75px]">
          <Button
            onClick={() => {
              setIsPaymentDialogOpen(false);
              form.setValue("value", "");
            }}
            className={investButtonClass}
          >
            <div
              className={`absolute flex ${
                !isLoading && "hidden"
              } items-center justify-center w-full h-full
             top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 `}
            >
              {" "}
              <Loader />
            </div>

            <span className="text-black max-lg:text-16m text-[16px] leading-[110%] font-[500]">
              {" "}
              {t("heroForm.continueToDashboard")}
            </span>
            <div className="bg-[#F3F3F8] max-lg:rounded-[8px] max-lg:w-[32px] max-lg:h-[32px] w-[32px] h-[32px] rounded-[8px] flex items-center justify-center">
              {" "}
              <ArrowForwardColoredIcon className="size-[18px]" />
            </div>
          </Button>
        </div>
      </div>
    </>
  );
}
